// TODO: Delete when consents texts are ready
const noop = () => {};
export function trackGAEvent({ event, userData, data }: DataLayerEvent) {
    window.dataLayer = window.dataLayer || [];

    const gaEvent: GaEvent = {
        event,
        ...data,
    };

    if (userData) {
        noop();
        // TODO: Uncomment when consents texts are ready
        // gaEvent.user_data = {
        //     email_address: userData?.email ?? '',
        //     phone_number: normalizePhone(userData?.phone),
        // };
    }

    window.dataLayer.push(gaEvent);
}

type Step = 'selectArrangement' | 'addToCart' | 'goToApplication';
type Programme = { id: string; name: string; campus: string };

export function trackGAEventForApplication(step: Step, programme: Programme[]) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'application',
        step,
        programme,
    });
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function normalizePhone(phoneNumber?: string): string {
    if (!phoneNumber) return '';

    const trimedPhone = phoneNumber.replace(/\s+/g, '');
    const isNorwegianNumber = (trimedPhone.startsWith('+47') && trimedPhone.length === 11) || trimedPhone.length === 8;

    if (isNorwegianNumber && trimedPhone.length === 8) {
        return `+47${trimedPhone}`;
    } else if (isNorwegianNumber && trimedPhone.length === 11) {
        return trimedPhone;
    }

    return '';
}

interface DataLayerEvent {
    event: string;
    userData?: UserData;
    data: Record<string, unknown>;
}

export interface UserData {
    email?: string;
    phone?: string;
}

interface GaUserData {
    email_address: string;
    phone_number: string;
}

interface GaEvent {
    event: string;
    user_data?: GaUserData;
    [key: string]: unknown;
}

declare global {
    interface Window {
        dataLayer: unknown[];
    }
}
